/**
 * Kopiert aus der ./bootstrap Tabelle
 * Der Nutzen von window. ist nicht bekannt. Es klappt ohne jedoch nicht
 */

window._ = require('lodash');
window.$ = window.jQuery = require('jquery');
/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */
window.axios = require('axios');
window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

// require('bootstrap/dist/js/bootstrap.bundle.min')
require('@itcenter-layout/bootstrap/dist/js/bootstrap.bundle.min');
require('datatables.net-bs5');
require('datatables.net-responsive-bs5');
// require('datatables.net-rowgroup-bs5');
require('jquery.fancytree');
require('jquery.fancytree/dist/modules/jquery.fancytree.glyph');
require('jquery.fancytree/dist/modules/jquery.fancytree.wide');
require('jquery.fancytree/dist/modules/jquery.fancytree.filter');

$(document).ready(function () {
    $('#print').click(function () {
        window.print();
    });
});

$(document).ready(function () {
    $('.collapse').on('hide.bs.collapse', function () {
        // smooth transition, use easing
        $(this).prev().children('.icons').animate({deg: -90}, {
            duration: 200,
            step: function (now) {
                $(this).css({transform: 'rotate(' + now + 'deg)'});
            }
        });
    });
    $('.collapse').on('show.bs.collapse', function () {
        $(this).prev().children('.icons').animate({deg: 0}, {
            duration: 200,
            step: function (now) {
                $(this).css({transform: 'rotate(' + now + 'deg)'});
            }
        });
    });

    // if div.collapse has no li element anymore, add d-none to icon
    // no event, because this is only for the first load
    $('.collapse').each(function () {
        if ($(this).children('ul').children('li').length == 0) {
            $(this).prev().children('.icons').addClass('d-none');
        } else {
            $(this).prev().css('cursor', 'pointer');
        }
    });
});
